import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;

  .containerCircularProgress {
    height: 28px;
    width: 28px;
  }

  .containerProgress {
    display: flex;
    align-items: center;
  }

  h4 {
    margin-left: 16px;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 21px;
    color: #1b2852;
    width: 80px;
  }
`;

export const TextMessage = styled.p<{ status?: "normal" | "danger" }>`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: ${({ status = "normal " }) =>
    status === "danger" ? "#D20E0E" : "#1b2852"};
  margin-left: 20px;
`;
